import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 27.4501H44.626V32.4964H0C0.00804265 35.3958 0.952733 38.4999 2.02134 41.1675C7.03141 53.6749 19.9286 61.178 33.2382 59.8482C47.871 58.3862 59.9284 45.3962 59.9996 30.6484C60.0167 27.0554 59.5248 23.4575 58.3133 20.0583C54.9025 10.4882 46.777 3.13389 36.8681 0.788703C22.7699 -2.54798 7.93539 4.97004 2.2476 18.2814C1.05458 21.0734 0.0254091 24.3866 0 27.4501Z"
      fill="#ECEDEE"
    />
  </svg>
)
